// tslint:disable:max-line-length (autogenerated)
// tslint:disable:no-any (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable-next-line:no-require-imports no-var-requires (autogenerated)
const MobileDetect = require('mobile-detect');
import FlashDetect from './flash-detect';

export interface IDetectedFeatures {
    mseSupported: boolean;
    autoPlaySupported: boolean;
    flashInstalled: boolean;
    isTablet: boolean;
    isPhone: boolean;
    isDesktop: boolean;
    isMobile: boolean;
    isIos: boolean;
    isAndroid: boolean;
    canPlayMultipleVideos: boolean;
    canPlayVideoInline: boolean;
    flashMajorVersion?: number;
    canControlVolume: boolean;
    os: string;
    mobileDetect: any;
}

const features: IDetectedFeatures = {
    mseSupported: false,
    autoPlaySupported: false,
    flashInstalled: false,
    isTablet: false,
    isPhone: false,
    isDesktop: true,
    isMobile: true,
    isIos: false,
    isAndroid: false,
    canPlayMultipleVideos: true,
    canPlayVideoInline: true,
    canControlVolume: true,
    os: '',
    mobileDetect: undefined
};

async function testAutoPlay(): Promise<{}> {
    // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
    return new Promise((resolve, reject) => {
        let timeout;
        const waitTime = 300;
        const docElement = document.documentElement;
        let elem;
        let elemStyle;
        try {
            elem = document.createElement('video');
            elemStyle = elem.style;
            // invisible
            elemStyle.position = 'absolute';
            elemStyle.height = '0';
            elemStyle.width = '0';
            // h264

            elem.src =
                'data:video/mp4;base64,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';

            elem.setAttribute('autoplay', '');
            elem.setAttribute('controls', false);
            elem.style.cssText = 'display:none';

            docElement.appendChild(elem);

            const volume = elem.volume;
            elem.volume = volume / 2 + 0.1;
            features.canControlVolume = volume !== elem.volume;
        } catch (e) {
            features.autoPlaySupported = false;
            resolve();
        }

        function testAutoPlayInner(arg: Event): void {
            features.autoPlaySupported = (arg && arg.type === 'playing') || elem.currentTime !== 0;
            clearTimeout(timeout);
            elem.removeEventListener('playing', testAutoPlayInner, false);
            elem.parentNode.removeChild(elem);
            resolve();
        }
        // wait for the next tick to add the listener, otherwise the element may
        // not have time to play in high load situations (e.g. the test suite)
        setTimeout(function(): void {
            elem.play();
            elem.addEventListener('playing', testAutoPlayInner, false);
            timeout = setTimeout(testAutoPlayInner, waitTime);
        }, 0);
    });
}

function testFlash(): void {
    try {
        features.flashInstalled = FlashDetect && FlashDetect.installed;
        features.flashMajorVersion = FlashDetect && FlashDetect.major;
    } catch (error) {
        features.flashInstalled = false;
    }
}

function testMobile(): void {
    try {
        const md = new MobileDetect(navigator.userAgent);
        features.mobileDetect = md;
        features.isTablet = !!md.tablet();
        features.isPhone = !!md.phone();
        features.isDesktop = !md.mobile();
        features.isMobile = !!md.mobile();
        features.os = md.os();
        features.isIos = features.os === 'iOS';
        features.isAndroid = features.os === 'AndroidOS';
    } catch (error) {
        // by default assume that it's desktop
        features.isTablet = false;
        features.isPhone = false;
        features.isDesktop = true;
        features.isMobile = false;
        features.isIos = false;
        features.isAndroid = false;
    }
}

function postProcess(detectedFeatures: IDetectedFeatures): void {
    // todo: think about better way of detection
    detectedFeatures.canPlayVideoInline = !detectedFeatures.isPhone;
    detectedFeatures.canPlayMultipleVideos = detectedFeatures.isDesktop;
    detectedFeatures.autoPlaySupported =
        detectedFeatures.autoPlaySupported || detectedFeatures.flashInstalled;
}

const CODECS_MUST_BE_SUPPORTED_BY_MSE_PLAYER = 'avc1.4D401E,avc1.4D401E,avc1.64001E,mp4a.40.2,mp4a.40.5';

export function detectMseSupport(): boolean {
    if (typeof MediaSource !== 'undefined') {
        return MediaSource.isTypeSupported(`video/mp4; codecs="${CODECS_MUST_BE_SUPPORTED_BY_MSE_PLAYER}"`);
    }
    return false;
}

let allTestsRun = false;
export async function runAllTests(): Promise<IDetectedFeatures> {
    if (allTestsRun) {
        return features;
    }
    testMobile();
    testFlash();
    if (!features.flashInstalled) {
        await testAutoPlay();
    }
    features.mseSupported = detectMseSupport();
    postProcess(features);
    allTestsRun = true;
    return features;
}
